// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".law_firm_header_infos-module__container--I6_Vx{font-weight:400;font-size:16px;line-height:24px;letter-spacing:0px;text-align:left}.law_firm_header_infos-module__item--ZSJQ2{margin-bottom:8px}.law_firm_header_infos-module__label--1n-C9{color:#616161}.law_firm_header_infos-module__value--8bgPC{color:#303030}.law_firm_header_infos-module__link--2DVc2:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"container": "law_firm_header_infos-module__container--I6_Vx",
	"item": "law_firm_header_infos-module__item--ZSJQ2",
	"label": "law_firm_header_infos-module__label--1n-C9",
	"value": "law_firm_header_infos-module__value--8bgPC",
	"link": "law_firm_header_infos-module__link--2DVc2"
};
module.exports = exports;
